"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = void 0;
var _auth = require("@ori/auth");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _Image = require("../Product/Image");
var _Labels = require("./Labels");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductInfo = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    currentProduct: {
      brandName,
      name
    },
    currentShade
  } = (0, _internal.useProduct)();
  const {
    bonusPoints,
    productCode,
    size
  } = currentShade;
  const formatedBonusPoints = bonusPoints > 0 && !isAnonymousUser ? `${bonusPoints} ${translations.bonusPoints}` : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.PRODUCT_INFO),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Labels.Labels, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.Names, {
        brandName: brandName,
        productName: name,
        size: "small"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.ProductDetails, {
        currentShade: currentShade,
        bonusPoints: formatedBonusPoints,
        productCode: productCode,
        size: size
      })]
    })]
  });
};
exports.ProductInfo = ProductInfo;